import { render, staticRenderFns } from "./ForwardPreview1.vue?vue&type=template&id=c38af824&scoped=true"
import script from "./ForwardPreview1.vue?vue&type=script&lang=js"
export * from "./ForwardPreview1.vue?vue&type=script&lang=js"
import style0 from "./ForwardPreview1.vue?vue&type=style&index=0&id=c38af824&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38af824",
  null
  
)

export default component.exports